<template>
    <div class="mod--row mod--row-flex mod--row-middle date-input-range-header"
         style="justify-content: center; margin-right: calc(1.25rem - 2px);margin-bottom: 0.5em; border: 1px solid #5E544A;">
        <div style="flex:1;display:flex;justify-content: center;align-items: center;flex-wrap: wrap;column-gap:20px">
            <div class="part_ui_date_picker_holder">
                <div style="text-transform: uppercase">{{ $t('from') }}:</div>
                <DateInput class="mod--header-picker" v-model="dateFrom" :clear-button="true" :max-date="dateTo"
                           :placeholder="$t('unlimited').toUpperCase()"/>
            </div>
            <div class="part_ui_date_picker_holder">
                <div style="text-transform: uppercase">{{ $t('to') }}:</div>
                <DateInput class="mod--header-picker" v-model="dateTo" :clear-button="true" :min-date="dateFrom"
                           :placeholder="$t('unlimited').toUpperCase()"/>
            </div>
        </div>
    </div>
</template>

<script>
import DateInput from './date_input';

export default {
    name: 'DateInputRangeHeader',
    props: ['from', 'to'],
    components: {
        DateInput
    },
    computed: {
        dateFrom: {
            get() {
                return this.from
            },
            set(value) {
                this.$emit('inputFrom', value)
            },
        },
        dateTo: {
            get() {
                return this.to
            },
            set(value) {
                this.$emit('inputTo', value)
            },
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/templates/part/item/date_input_range_header.vue